import { render, staticRenderFns } from "./SummaryShipment.vue?vue&type=template&id=0f2c3a16&scoped=true&lang=pug"
import script from "./SummaryShipment.vue?vue&type=script&lang=js"
export * from "./SummaryShipment.vue?vue&type=script&lang=js"
import style0 from "./SummaryShipment.vue?vue&type=style&index=0&id=0f2c3a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c3a16",
  null
  
)

export default component.exports